import { View, Text, TouchableOpacity, ActivityIndicator } from "react-native";
import React from "react";
import HistoryIcon from "../../assets/svg/HistoryIcon";
import WalletIcon from "../../assets/svg/WalletIcon";
import PlusIcon from "../../assets/svg/PlusIcon";
import MyText from "../custom/MyText";
import translate from "../../functions/translate";
import { gray, primary, shadowSm, white } from "../../colors";
import { LinearGradient } from "expo-linear-gradient";
import { useState } from "react";
import { useEffect } from "react";
import getBalance from "../../api/wallet/getBalance";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import { useSelector } from "react-redux";
import getToken from "../../api/token";
import { Toast } from "react-native-toast-message/lib/src/Toast";
import { currencyFormat } from "../../functions/functions";

export default function Wallet(props) {
  const navigation = useNavigation();
  const [balance, setBalance] = useState(0);
  const main = useSelector((store) => store.main);
  const isFocused = useIsFocused();
  const [loading, setLoading] = useState(false);
  const currency = main.rtl ? "IR" : "US";
  useEffect(() => {
    if (main.token !== null) {
      setLoading(true);

      getBalance(currency)
        .then(({ data }) => {
          setLoading(false);
          if (data.status === 200) {
            setBalance(data.inventory);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  }, [main]);
  useEffect(() => {
    if (isFocused) {
      main.token === null ? setBalance(0) : null;

      getBalance(currency)
        .then(({ data }) => {
          if (data.status === 200) {
            setBalance(data.inventory);
          }
        })
        .catch((err) => {});
    }
  }, [props.changed, isFocused]);

  return (
    <View style={{ width: "100%", alignItems: "center" }}>
      {loading ? (
        <ActivityIndicator size="large" />
      ) : (
        <View
          style={{
            marginVertical: 20,
            width: "92%",
            borderRadius: 10,
            borderWidth: 2,
            borderColor: "#f9f9f9",

            overflow: "hidden",
          }}
        >
          <View
            style={{ flexDirection: "row", alignItems: "center", padding: 5 }}
          >
            <View>
              <WalletIcon />
            </View>
            <View>
              <MyText
                style={{ color: primary, fontSize: 26, marginHorizontal: 10 }}
              >
                {translate("wallet")}
              </MyText>
            </View>
            <View style={{ flex: 1 }}></View>
            <TouchableOpacity
              onPress={() =>
                main.token !== null
                  ? navigation.navigate("Wallet", { mode: "transactions" })
                  : Toast.show({
                      type: "error",
                      text1: translate("please login first"),
                    })
              }
              style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                borderWidth: 1,
                borderColor: "gray",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <HistoryIcon />
            </TouchableOpacity>
          </View>
          <View
            style={{
              width: "100%",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <View style={{ marginVertical: 15 }}>
              <MyText style={{ fontSize: 20, color: gray }}>
                {translate("your balance")}
              </MyText>
            </View>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              {/* {balance >= 1000 && (
              <View
                dir="ltr"
                style={{
                  flexDirection: "row",
                  direction: "ltr",
                  alignItems: "flex-end",
                }}
              >
                <MyText style={{ fontSize: 28 }}>{`${Math.floor(
                  balance / 1000
                )}`}</MyText>
                <MyText
                  style={{
                    fontSize: 20,
                    color: gray,
                    marginHorizontal: 2,
                    marginTop: -5,
                  }}
                >
                  {`${balance % 1000}`}
                </MyText>
              </View>
            )} */}
              <View
                dir="ltr"
                style={{
                  flexDirection: "row",
                  direction: "ltr",
                  alignItems: "flex-end",
                }}
              >
                <MyText
                  style={{ fontSize: 28, paddingBottom: 2 }}
                >{`${currencyFormat(balance)}`}</MyText>
              </View>
              <View style={{ marginHorizontal: 10 }}>
                <MyText style={{ fontSize: 22, color: primary }}>
                  {translate("currency")}
                </MyText>
              </View>
            </View>
          </View>
          <TouchableOpacity
            onPress={() =>
              main.token !== null
                ? navigation.navigate("Wallet", { mode: "charge" })
                : Toast.show({
                    type: "error",
                    text1: translate("please login first"),
                  })
            }
            style={{
              width: "100%",
              padding: 10,
              minHeight: 40,
              marginTop: 20,
              bottom: 0,
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(72, 169, 194, 0.9)",
            }}
          >
            <View style={{ marginHorizontal: 5 }}>
              <PlusIcon />
            </View>
            <MyText style={{ fontSize: 18, color: white, fontWeight: "bold" }}>
              {translate("charge wallet")}
            </MyText>
          </TouchableOpacity>
        </View>
      )}
    </View>
  );
}
